// Copy on /restaurants that is still being decided. Change it here; the page and its test both read it.

/** The title over the three cards under the video. Deuce picked it on Oct 30. */
export const PROPS_TITLE = 'Why restaurants say yeah.';
